import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import styles from "./Post.module.scss";
import _ from "lodash";
import VerticalItem from "@components/Home/OurStory/VerticalItem";
import HorizontalItem from "@components/Home/OurStory/HorizontalItem";
import renderPropsComposer from "@utils/renderPropsComposer";
import Divider from "@components/Divider";
const View = ({ data, divider = true }: any) => {
  const { i18n } = useTranslationContext();
  const lists: any = [[], []];
  _.map(data, (item: any, index: number) => {
    if (index % 2 === 0) {
      lists[0].push(item);
    } else {
      lists[1].push(item);
    }
  });
  //   const lists = _.chunk(data, _.round(data.length / 2));
  // console.log({ lists });
  return (
    <section className={cx(styles.section)}>
      {!!divider && (
        <div className="inner-large">
          <Divider
            label={
              <span className="text-c-1">
                {i18n.t("Stories.lastestStories")}
              </span>
            }
          />
        </div>
      )}

      <div className={cx("inner-large", styles.box)}>
        {_.map(lists, (list, index: number) => {
          const left = index % 2 === 0;
          const right = index % 2 !== 0;
          return (
            <div
              className={cx({
                [styles.colL]: left,
                [styles.colR]: right,
              })}
            >
              {_.map(list, (item, j) => {
                return renderPropsComposer(
                  {
                    matcher: ({ index, left }: any) => left && index % 2 === 0,
                    render: ({ item, key }: any) => (
                      <VerticalItem
                        key={key}
                        {...item}
                        className={cx(styles.vertical)}
                      />
                    ),
                  },
                  {
                    matcher: ({ index, left }: any) => left && index % 2 !== 0,
                    render: ({ item, key }: any) => (
                      <HorizontalItem key={key} {...item} />
                    ),
                  },
                  {
                    matcher: ({ index, right }: any) =>
                      right && index % 2 === 0,
                    render: ({ item, key }: any) => (
                      <HorizontalItem key={key} {...item} />
                    ),
                  },
                  {
                    matcher: ({ index, right }: any) =>
                      right && index % 2 !== 0,
                    render: ({ item, key }: any) => (
                      <VerticalItem
                        key={key}
                        {...item}
                        className={cx(styles.vertical)}
                      />
                    ),
                  }
                )({ item, index: j, key: `card_${index}_${j}`, left, right });
              })}
            </div>
          );
        })}
        {/* <div className={styles.colL}>
          <VerticalItem {...POSTS[0]} className={cx(styles.vertical)} />
          <HorizontalItem {...POSTS[1]} />
        </div>
        <div className={styles.colR}>
          <HorizontalItem {...POSTS[2]} />
          <VerticalItem {...POSTS[3]} className={cx(styles.vertical)} />
        </div> */}
      </div>
    </section>
  );
};
export default View;
